export class Area {
    id: number | undefined;
    dbId: number | undefined;
    parentId: number | undefined;
    name: string | undefined;
}